module.exports = __webpack_public_path__ + "static/media/PATS_6-1363w.e88ad86c.png";